module.exports = __webpack_public_path__ + "static/c2-5c21ec0f8cbc04cdb89dde4ef53ee14a.jpg";